<mat-card class="all-devices">
  <mat-card-header class="card-header">
    <div class="container">
      <mat-card-title>
        <div *ngIf="buttonActive" class="flex">
          <div *ngIf="isRoot !== undefined && !isRoot" class="col-1 initial">
            <mat-icon
              (click)="goBackButton()"
              class="pointer unselectable verticalCenteredIcon"
            >
              keyboard_backspace
            </mat-icon>
          </div>
          <div [ngClass]="isRoot ? 'col-12' : 'col-11 titleWithButton'">
            {{ title }}
          </div>
        </div>
        <div *ngIf="deviceNavigate">
          <div class="col-12">
            {{ title }}
          </div>
        </div>
      </mat-card-title>
    </div>
  </mat-card-header>
  <mat-card-content class="card-content-devices style">
    <div *ngIf="!loading; else showSpinner">
      <div *ngIf="!hasChildren(itemCollection)">
        <div class="container mtop5">
          <div class="text-center">
            <h4>{{ "WARNING_MESSAGES.NO_DEVICES" | translate }}</h4>
          </div>
        </div>
      </div>
    </div>

    <div
      class="dispositivos"
      *ngFor="let item of itemCollection"
      id="selectorDispTD"
    >
      <mat-card class="card-dispositivos">
        <mat-card-header
          class="card-header-dispositivos"
          [ngClass]="!buttonActive ? ' effectSelectDevice' : ''"
        >
          <div class="container">
            <div
              [ngClass]="
                item?.selectedState == 'notSelectable' ? 'disabledDevice' : ''
              "
              class="row"
            >
              <div
                mat-card-avatar
                class="col-md-9 margen-dispositivos-alarma"
                id="prueba"
              >
                <app-blue-icon class="dib" name="device"></app-blue-icon>
                <mat-card-title class="dib ml2">{{
                  item?.name
                }}</mat-card-title>
              </div>
              <div class="col-md-3 pull-right">
                <div *ngIf="buttonActive">
                  <div class="col-md-6 divNavigateButtons">
                    <button
                      type="button"
                      class="button button10"
                      *ngIf="
                        item?.selectedState != 'notSelectable';
                        else notCompatible
                      "
                      mat-icon-button
                      (click)="onClickItem(item)"
                    >
                      <i
                        *ngIf="item?.selectedState == 'selectable'"
                        class="material-icons green"
                      >
                        add_circle
                      </i>
                      <mat-icon
                        *ngIf="item?.selectedState == 'selected'"
                        class="material-icons red"
                      >
                        clear
                      </mat-icon>
                    </button>
                  </div>
                  <div class="col-md-6 divNavigateButtons">
                    <button
                      type="button"
                      class="button button10"
                      *ngIf="item?.childrenNumber != 0"
                      mat-icon-button
                      (click)="onClickItemNavegate(item)"
                    >
                      <mat-icon class="material-icons blue">
                        <!-- <app-svg name="circle-right" width="5" height="5"></app-svg> -->
                        keyboard_tab
                      </mat-icon>
                    </button>

                    <ng-template #notCompatible>
                      <button
                        type="button"
                        style="margin-left: 2rem"
                        disabled
                        mat-icon-button
                        (click)="onClickItem(item)"
                        title="Este dispositivo no puede ser seleccionado"
                      >
                        <mat-icon
                          class="icono-preview colorGreenHighlight marginTop8"
                        >
                          <div class="icono-checked">
                            <app-svg name="done"></app-svg>
                          </div>
                        </mat-icon>
                      </button>
                    </ng-template>
                  </div>
                </div>

                <div *ngIf="deviceNavigate">
                  <div>
                    <button
                      type="button"
                      class="pull-right"
                      mat-icon-button
                      (click)="onClickItemNavegate(item)"
                    >
                      <mat-icon
                        class="icono-preview colorGreenHighlight navigate"
                      >
                        <app-svg
                          name="circle-right"
                          width="5"
                          height="5"
                        ></app-svg>
                      </mat-icon>
                    </button>
                    <!-- <button type="button" mat-icon-button class="left pull-right"
                                            (click)="openDialog(item)">
                                            <mat-icon>
                                                <app-svg [name]="'edit'" class="iconEdit"></app-svg>
                                            </mat-icon>
                                        </button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-header>
      </mat-card>
    </div>

    <ng-template #showSpinner>
      <app-loading [loadingText]="loadingText"></app-loading>
    </ng-template>
  </mat-card-content>
</mat-card>
